import { Button } from 'components/atoms';
import { PublicPage } from 'components/templates';
import { useTranslation } from 'react-i18next';
import { PiLockKeyOpen } from 'react-icons/pi';
import { useCurrentServiceCode } from 'services/serviceCode';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ServiceCode = () => {
  const { data, refetch, isFetching, isPending } = useCurrentServiceCode();
  const { t } = useTranslation();

  return (
    <PublicPage
      wrapperContentStyle={{ gap: 0 }}
      withConsent={false}
      header={
        <>
          <PiLockKeyOpen />
          {t('serviceCode.currentServiceCode')}
        </>
      }
      footer={<div className='w-72 opacity-65'>{t('serviceCode.footer')}</div>}>
      <p className={'text-[28px]'}>{data || t('serviceCode.reload')}</p>
      <Button
        type='submit'
        onClick={() => refetch()}
        variant={BUTTON_VARIANT.submit}
        isLoading={isFetching || isPending}>
        <Button.Text text={t('serviceCode.checkForNew')} />
      </Button>
    </PublicPage>
  );
};

export default ServiceCode;
